import React, { useContext, useState, useEffect } from "react";
import { useTable } from "react-table";
import PropTypes from "prop-types";
import { CommentModal } from "../comment-modal/commentModal";
import { StatusDropdown } from "../status-dropdown/status-dropdown";
// import { NextCallbackModal } from "../nexcallback/nextcallback-modal";
import { CallBackContext } from "../../../contexts";
import { ActionModal } from "../../../components/action-modal/actionModal";
import moment from "moment";
import { Modal } from "flowbite-react";
import { ROLES } from "../../../utils/constants";
import Cookies from "js-cookie";
import { updateCallback } from "../../../hooks/update-hooks/update-callbacks/update-callback";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { OrderValueModal } from "../orderValue-modal/orderValueModal";
import UTMParamsModal from "../../../components/utm-params-modal/UTMParamsModal";
import { STATUS_COLORS } from "../constants";
import { LostDropdown } from "../status-dropdown/lost-dropdown";
import { LostReasonDropdown } from "../status-dropdown/lost-reason-dropdown";

const AttemptInputModal = ({ callback, attemptNumber }) => {
    const [show, setShow] = useState(false);
    const { refetch } = useContext(CallBackContext);

    return (
        <div>
            <span className="cursor-pointer" onClick={() => setShow(true)}>
                {callback.additionalDetails?.[`a${attemptNumber}`]?.date
                    ? moment(callback.additionalDetails?.[`a${attemptNumber}`]?.date).format("DD/MM/YY")
                    : "N/A"}
            </span>
            {show && (
                <AttemptInputFormModal
                    show={show}
                    setShow={setShow}
                    callback={callback}
                    attemptNumber={attemptNumber}
                    refetch={refetch}
                />
            )}
        </div>
    );
};

const AttemptInputFormModal = ({ setShow, callback, attemptNumber, refetch }) => {
    const [attemptDate, setAttemptDate] = useState("");
    const [attemptComment, setAttemptComment] = useState("");

    useEffect(() => {
        setAttemptDate(callback.additionalDetails?.[`a${attemptNumber}`]?.date
            ? moment(callback.additionalDetails?.[`a${attemptNumber}`]?.date).format("YYYY-MM-DD")
            : "");
    }, [callback.additionalDetails?.[`a${attemptNumber}`]?.date]);

    useEffect(() => {
        setAttemptComment(callback.additionalDetails?.[`a${attemptNumber}`]?.comment);
    }, [callback.additionalDetails?.[`a${attemptNumber}`]?.comment]);

    const updateAttemptComment = async () => {
        try {
            const res = await updateCallback({
                'additionalDetails': {
                    ...callback.additionalDetails,
                    [`a${attemptNumber}`]: {
                        date: new Date(attemptDate),
                        comment: attemptComment || ""
                    }
                }
            }, parseInt(callback.id))
            if (res.data && res.data.success) {
                toast.success("Attempt comment updated successfully")
                refetch();
            } else {
                toast.error("Failed to update attempt comment")
            }
        } catch (error) {
            toast.error("Failed to update attempt comment")
        }
    }

    useEffect(() => {
        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                setShow(false);
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [setShow]);

    return (
        <div
            style={{ width: '100vw' }}
            className="flex flex-col justify-center fixed top-0 left-0 bg-black/50 z-50 h-[100vh] w-[100vw]"
        >
            <div
                style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}
                className="flex flex-col gap-4 justify-center p-6 rounded-md"
            >
                <div className="flex flex-row justify-between">
                    <h1 className="text-2xl font-bold">Attempt Input</h1>
                    <button className="text-black px-4 py-2 rounded-md" onClick={() => setShow(false)}><FontAwesomeIcon icon={faXmark} /></button>
                </div>
                <hr className="border-gray-300" />
                <input
                    type="date"
                    value={attemptDate}
                    onChange={(e) => setAttemptDate(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-md"
                />
                <textarea
                    value={attemptComment}
                    onChange={(e) => setAttemptComment(e.target.value)}
                    className="px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Enter comment"
                    autoFocus
                />
                <button
                    disabled={!attemptDate || !attemptComment}
                    className="bg-[#00A48B] text-white-50 px-4 py-2 rounded-md disabled:opacity-50"
                    onClick={async () => {
                        await updateAttemptComment()
                        setShow(false)
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

AttemptInputFormModal.propTypes = {
    show: PropTypes.bool,
    setShow: PropTypes.func,
    callback: PropTypes.object,
    attemptNumber: PropTypes.number,
    refetch: PropTypes.func
};

const SupportDetailsModal = ({ support }) => {
    const [show, setShow] = useState(false);

    return (
        <div>
            <button className="cursor-pointer text-blue-500 bg-blue-100 rounded-md px-2 py-1" onClick={() => setShow(true)}>
                Support Details
            </button>
            {<Modal Modal style={{ width: '100vw' }}
                className="w-full flex justify-center"
                show={show}
                size={'100vw'}
                onClose={() => {
                    setShow(false)
                }}>
                <Modal.Header style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}>
                    Support Details
                </Modal.Header>
                <Modal.Body
                    style={{ backgroundColor: "white", width: "36vw", marginLeft: "32vw" }}
                    className="flex flex-col gap-4 justify-center"
                >
                    <p className="text-lg font-sans"><span className="font-bold">ID:</span> {support?.id}</p>
                    <p className="text-lg font-sans"><span className="font-bold">Name:</span> {support?.name}</p>
                    <p className="text-lg font-sans"><span className="font-bold">Contact:</span> {support?.contact_no}</p>
                </Modal.Body>

            </Modal>
            }
        </div>
    )
}

SupportDetailsModal.propTypes = {
    support: PropTypes.object
};

AttemptInputModal.propTypes = {
    callback: PropTypes.object,
    attemptNumber: PropTypes.number
};

export default function TableLayout() {
    const { data, columns, refetch } = useContext(CallBackContext);
    const [selectedHamburger, setSelectedHamburger] = useState(null);

    const userRoles = Cookies.get('roles') ? JSON.parse(Cookies.get('roles')) : null;

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data
    })

    const roles = Cookies.get('roles') ? JSON.parse(Cookies.get('roles')) : null;

    function renderCellComponent(cell) {
        const { Header } = cell.column;
        const { original } = cell.row;

        switch (Header) {
            case "Action":
                return <td className="px-2 text-left w-fit" key={`${original.id}_prescription`}><ActionModal original={original} prescription={original.links} setSelectedHamburger={setSelectedHamburger} selectedHamburger={selectedHamburger} /></td>;
            case "Type":
                return <td className="px-2 text-left w-fit text-[9px]" key={`${original.id}_prescription`}>{original.type.split("_").join(" ")}</td>;
            case "Comment":
                return <td className="px-2 text-left" key={`${original.id}_comment`}><CommentModal callback={original} /></td>;
            case "Order Value":
                return <td className="px-2 text-left" key={`${original.id}_order_value`}><OrderValueModal callback={original} /></td>;
            case "Status":
                return userRoles.includes(ROLES.MARKETING) ? <td className="px-2 text-left" key={`${original.id}_status`}>{original.status}</td> : <td className="px-2 text-left" key={`${original.id}_status`}><StatusDropdown cell={cell} callback={original} refetch={refetch} /></td>;
            case "Lost":
                return <td className="px-2 text-left" key={`${original.id}_status`}><LostDropdown cell={cell} callback={original} refetch={refetch} /></td>;
            case "Lost Reason":
                return <td className="px-2 text-left" key={`${original.id}_status`}><LostReasonDropdown cell={cell} callback={original} refetch={refetch} /></td>;
            // case "NextCallback":
            //     return <td className="px-2 text-left" key={`${original.id}_next_callback`}><NextCallbackModal callback={original} /></td >;
            case "Created":
                return <td className="px-2 text-left" key={`${original.id}_created_on`}>{moment(original.createdAt).format("DD/MM/YY")}<br />{moment(original.createdAt).format("HH:mm:ss")}</td >;
            case "A1":
                return <td className="px-2 text-left" key={`${original.id}_created_on`}><AttemptInputModal callback={original} attemptNumber={1} /></td >;
            case "A2":
                return <td className="px-2 text-left" key={`${original.id}_created_on`}><AttemptInputModal callback={original} attemptNumber={2} /></td >;
            case "A3":
                return <td className="px-2 text-left" key={`${original.id}_created_on`}><AttemptInputModal callback={original} attemptNumber={3} /></td >;
            case 'Source':
                return <td className="px-2 text-left" key={`${original.id}_source`}><UTMParamsModal original={original} type="source" /></td>
            case 'Medium':
                return <td className="px-2 text-left" key={`${original.id}_medium`}><UTMParamsModal original={original} type="medium" /></td>
            case 'Campaign':
                return <td className="px-2 text-left" key={`${original.id}_campaign`}><UTMParamsModal original={original} type="campaign" /></td>
            case 'City':
                return <td className="px-2 text-left" key={`${original.id}_city`}>{original?.additionalDetails?.location?.district || "N/A"}</td>
            case 'State':
                return <td className="px-2 text-left" key={`${original.id}_state`}>{original?.additionalDetails?.location?.state || "N/A"}</td>
            case 'Pincode':
                return <td className="px-2 text-left" key={`${original.id}_pincode`}>{original?.additionalDetails?.location?.pincode || "N/A"}</td>
            case "Name":
                return <td className="pl-3 py-4 text-left text-lg font-sans font-size-xl" key={`${original.id}_name`} {...cell.getCellProps()}> <h1 className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {original.mapUserPatient?.Patient?.name && <b className="text-lg flex items-center gap-1">
                        {original.links && original.links.length > 0 && <div className="w-[10px] h-[10px] bg-elm-500 rounded-full" />} {original.mapUserPatient?.Patient?.name || original.name} ({moment().diff(original.mapUserPatient?.Patient?.dob, 'years')}{original.mapUserPatient?.Patient?.gender}): &nbsp;
                    </b>}
                    {
                        original?.additionalDetails?.platform === 'WATI' ? <a target="_blank" rel="noreferrer" href={`https://live.wati.io/395647/teamInbox/682d7c4d61a576b45ae0f80b?search={%22searchString%22:%22${original.mapUserPatient?.Patient?.contact_no || original?.phoneNumber}%22}`} className="text-elm-500 text-lg underline">
                            {original.mapUserPatient?.Patient?.contact_no || original?.phoneNumber}
                        </a> : <span className="text-elm-500 text-lg">
                            {original.mapUserPatient?.Patient?.contact_no || original?.phoneNumber}
                        </span>
                    }
                    {
                        original.mapUserPatient?.User && original.mapUserPatient?.Patient && original.mapUserPatient?.User?.id !== original.mapUserPatient?.Patient?.id &&
                        <>
                            <div>
                                <b className="text-blue-500 text-lg">
                                    &nbsp; {[original.mapUserPatient?.relationship === "OLD" ? "" : original.mapUserPatient?.relationship?.toLowerCase()]}
                                </b>
                                <br />
                                <b className="text-lg">
                                    {original.mapUserPatient?.User?.name} ({moment().diff(original.mapUserPatient?.User?.dob, 'years')}{original.mapUserPatient?.User?.gender}):
                                </b>
                                &nbsp;
                            </div>
                            <span className="text-elm-500 text-lg">
                                {original.mapUserPatient?.User?.contact_no}
                            </span>
                        </>
                    }
                </h1>
                    {(roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.MARKETING)) && original?.Support && <SupportDetailsModal support={original?.Support} />}
                </td>
            case "#":
                return (
                    <td
                        {...cell.getCellProps()}
                        className="py-4 text-left pl-3 font-sans cursor-pointer hover:text-black text-elm-500 font-medium"
                        key={original.id}>
                        {cell.render("Cell")}
                    </td>
                )
            default:
                return <td className="px-2 text-left" key={`${original.id}_${cell.getCellProps().key}`} {...cell.getCellProps()}> {cell.render("Cell")}</td >;
        }
    }

    return (
        <div className="block bg-white rounded-2xl shadow-soft-xl w-[100%] bg-[white] mt-4 p-2 px-4  dark:hover:bg-gray-700 overflow-y-scroll">
            <table {...getTableProps()} className="table-auto w-[100%] font-sans">
                <thead className="text-center border-b-2 border-gray-50 h-16">
                    {headerGroups.map((headerGroup, id) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={id} className="text-left border-b-2 border-gray-100">

                            {headerGroup.headers.map((column, id) => (
                                <th {...column.getHeaderProps()} key={id} className="font-sans text-left pl-3">{column.render("Header")}</th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row, id) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} key={id} className={`px-2 border-b text-left border-gray-50 pl-3 font-sans`} style={{ backgroundColor: STATUS_COLORS[row.original.status] }}>
                                {row.cells.map((cell, id) => {
                                    return <React.Fragment key={id}>
                                        {renderCellComponent(cell)}
                                    </React.Fragment>
                                })}

                            </tr>
                        );
                    })}
                </tbody>
            </table >
        </div>
    )

}
TableLayout.propTypes = {
    columns: PropTypes.any,
    data: PropTypes.any,
    refetch: PropTypes.any
};




